import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';

const ViewStudentModal = ({ show, onHide, student, onEdit, onPrintCard, onPrintSlip }) => {
  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-IN');
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Student Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center mb-4">
          <img
            src={student?.photoURL || '/default-avatar.png'}
            alt={student?.studentName}
            className="rounded-circle me-3"
            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
          />
          <div>
            <h4 className="mb-1">{student?.studentName}</h4>
            <p className="text-muted mb-0">Roll No: {student?.rollNumber}</p>
          </div>
        </div>

        <Row className="g-3">
          <Col md={6}>
            <h6>Personal Information</h6>
            <table className="table">
              <tbody>
                <tr>
                  <td>Grade/Section</td>
                  <td>{student?.grade} - {student?.section}</td>
                </tr>
                <tr>
                  <td>Gender</td>
                  <td>{student?.gender}</td>
                </tr>
                <tr>
                  <td>Date of Birth</td>
                  <td>{formatDate(student?.dateOfBirth)}</td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col md={6}>
            <h6>Contact Information</h6>
            <table className="table">
              <tbody>
                <tr>
                  <td>Phone</td>
                  <td>{student?.phone || 'N/A'}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>{student?.email || 'N/A'}</td>
                </tr>
                <tr>
                  <td>Address</td>
                  <td>{student?.address || 'N/A'}</td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
        <Button variant="primary" onClick={() => onEdit(student)}>Edit</Button>
        <Button variant="info" onClick={() => onPrintCard(student)}>Print ID Card</Button>
        <Button variant="success" onClick={() => onPrintSlip(student)}>Print Registration</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewStudentModal;
